import { createStore, applyMiddleware, combineReducers } from "redux";
import { thunk } from "redux-thunk";
import { composeWithDevTools } from "@redux-devtools/extension";
import globalFilterReducer from "./reducers/globalFilterReducer";
import serviceIndicatorReducer from "./reducers/serviceIndicatorReducer";
import activeServiceReducer from "./reducers/activeServiceReducer";

const rootReducer = combineReducers({
  globalFilter: globalFilterReducer,
  serviceIndicator: serviceIndicatorReducer,
  activeService: activeServiceReducer,
});

const store = createStore(
  rootReducer,
  composeWithDevTools(applyMiddleware(thunk))
);

export default store;
